<div class="alert alert-info alert-dismissible mb-0">
  <a class="alert-link-icon me-1" [routerLink]="['/entity/', entityType | snakeCase, entity.id]">
    <con-icon-by-name [iconName]="entityDescription.getIcon()" [mutations]="['fw']"></con-icon-by-name>
    <small>({{ entity.id }})</small>
  </a>
  <strong>{{ entityDescription.getPrimaryString(entity) }}</strong>
</div>
